export const COBRAND_QUERY_NAME = 'cobrand'
